import { HelmetProvider } from 'react-helmet-async'

import { CookieConsent } from '@/components/CookieConsent'
import { CookieConsentProvider } from '@/hooks/useCookieConsent'
import { RoutingComponent } from '@/navigation/RoutingComponent'
import { Sentry } from '@/sentry'

import { ErrorPage } from './ErrorPage'

export function App() {
    return (
        <Sentry.ErrorBoundary fallback={<ErrorPage />} showDialog>
            <HelmetProvider>
                <CookieConsentProvider>
                    <RoutingComponent />
                    <CookieConsent />
                </CookieConsentProvider>
            </HelmetProvider>
        </Sentry.ErrorBoundary>
    )
}
